import type { CfaoVehicle } from "../data/cfaoVehicles";
import filterOptionsData from "../data/cfaoFilterOptions.json";

export type VehicleSearchScope = "all" | "make" | "model" | "year" | "body" | "price" | "transmission";

export const publicVehicles = (vehicles: CfaoVehicle[]) => vehicles.filter((vehicle) =>
  vehicle.status === "published"
  &&
  vehicle.price >= 0
  && vehicle.price <= 3_500_000
  && vehicle.year >= filterOptionsData.yearMin
  && vehicle.year <= filterOptionsData.yearMax
  && vehicle.mileage >= filterOptionsData.mileageMin
  && vehicle.mileage <= filterOptionsData.mileageMax
);

const normalize = (value: string | number) => String(value).trim().toLowerCase();

export const vehicleSearchText = (vehicle: CfaoVehicle, scope: VehicleSearchScope = "all") => {
  const values: Record<VehicleSearchScope, string> = {
    all: `${vehicle.fullTitle} ${vehicle.make} ${vehicle.model} ${vehicle.year} ${vehicle.bodyType} ${vehicle.fuelType} ${vehicle.transmission} ${vehicle.color} ${vehicle.id}`,
    make: vehicle.make,
    model: vehicle.model,
    year: String(vehicle.year),
    body: vehicle.bodyType,
    price: String(vehicle.price),
    transmission: vehicle.transmission,
  };
  return normalize(values[scope]);
};

export const matchesVehicleSearch = (vehicle: CfaoVehicle, query: string, scope: VehicleSearchScope = "all") => {
  if (scope === "price") {
    const trimmed = normalize(query);
    if (!trimmed) return true;
    const parsePrice = (value: string) => Number(value.replace(/[^\d]/g, ""));
    const range = trimmed.split(/\s*(?:-|\bto\b)\s*/i);
    if (range.length === 2) {
      const minimum = parsePrice(range[0]);
      const maximum = parsePrice(range[1]);
      return Number.isFinite(minimum) && Number.isFinite(maximum) && vehicle.price >= minimum && vehicle.price <= maximum;
    }
    const amount = parsePrice(trimmed);
    if (!Number.isFinite(amount)) return false;
    if (/\b(under|below|less|max|up to)\b/.test(trimmed)) return vehicle.price <= amount;
    if (/\b(over|above|more|min|from)\b/.test(trimmed)) return vehicle.price >= amount;
    return String(vehicle.price).includes(String(amount));
  }
  const terms = normalize(query).split(/\s+/).filter(Boolean);
  if (!terms.length) return true;
  const haystack = vehicleSearchText(vehicle, scope);
  return terms.every((term) => haystack.includes(term));
};
